import { cn } from "@/common/helpers/utils";
import type { ReactNode } from "react";

export function DetailTabGrid({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn("grid grid-cols-1 gap-6 lg:grid-cols-2 xl:grid-cols-3", className)}>{children}</div>;
}
